/**
 * components/landing/BrandLogo.jsx — Kalki Ai Cloud brand lockup.
 *
 * Renders the official full logo artwork (/kalkiai-full-logo.png —
 * gold crest + KALKI AI wordmark, transparent PNG) with NO text
 * suffix — the artwork speaks for itself.
 *
 *   variant="horizontal" (default) — full logo artwork
 *   variant="mark"                 — crest only (badges, favicons)
 */
import Link from '@/shims/NextLink'
import clsx from 'clsx'

const SIZE_TABLE = {
  xs: 14,
  sm: 26,
  md: 30,
  lg: 40,
  xl: 52,
}

const BrandLogo = ({
  variant = 'horizontal',
  size = 'md',
  href = '/',
  className = '',
  showWordmark = true, // kept for API compat; artwork already contains the wordmark
}) => {
  const imgH = SIZE_TABLE[size] || SIZE_TABLE.md

  const logoImg =
    variant === 'mark' ? (
      <img
        src="/kalkiai-crest.png"
        alt="Kalki Ai Cloud"
        height={imgH}
        className="object-contain drop-shadow-[0_0_18px_rgba(255,193,7,0.35)]"
        style={{ height: imgH, width: 'auto' }}
      />
    ) : (
      <img
        src="/kalkiai-full-logo.png"
        alt="Kalki Ai Cloud"
        height={imgH}
        className="object-contain drop-shadow-[0_0_18px_rgba(255,193,7,0.25)]"
        style={{ height: imgH, width: 'auto' }}
      />
    )

  const inner = (
    <span className={clsx('inline-flex items-center leading-none select-none', className)}>
      {logoImg}
    </span>
  )

  if (!href) return inner
  return (
    <Link href={href} className="inline-flex focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-400/60 rounded" data-testid="brand-logo">
      {inner}
    </Link>
  )
}

export default BrandLogo
